import { removeClass } from '../../js/shared/utils.js';

(function() {

    if (!document.querySelector('.form-dropdown')) {
        return;
    }

    // Получить все значения активных чекбоксов

    const getCheckboxesSummary = (dropdown) => {
        let summaries = [];
        const allCheckedTexts = dropdown.querySelectorAll('.form-checkbox__control:checked ~ .form-checkbox__text');

        if (allCheckedTexts.length) {
            for (let i = 0; i < allCheckedTexts.length; i++) {
                const text = allCheckedTexts[i].innerText.trim();
                if (text) {
                    summaries.push(text);
                }
            }
        }

        return summaries.join(', ');
    }

    // установить значение в дропдаун

    const setSummary = (dropdown, summary) => {
        const summaryPlace = dropdown.querySelector('.form-dropdown-control__text');
        const summaryInput = dropdown.querySelector('.js-dropdown-result');

        if (!summary) {
            summary = summaryPlace.getAttribute('data-placeholder');
            dropdown.classList.remove('is-selected');
        } else {
            dropdown.classList.add('is-selected');
        }

        summaryPlace.innerText = summary;
        summaryInput.value = summary;
    }

    // закрыть все дропдауны

    const closeAllDropdowns = () => {
        const dropdowns = document.querySelectorAll('.form-dropdown');
        if (dropdowns.length) {
            for (let i = 0; i < dropdowns.length; i++) {
                dropdowns[i].classList.remove('is-opened');
            }
        }
    }

    // снять активность со всех элеметов одиночного выбора
    const deselectChoices = (dropdown) => {
        const choices = dropdown.querySelectorAll('.form-dropdown-choice');
        if (choices.length) {
            removeClass(choices, 'is-selected');
        }
    }


    // Контроллер кликов

    document.addEventListener('click', e => {
        const target = e.target;
        const dropdown = target.closest('.form-dropdown');

        if (dropdown) {

            // если кликнули на триггер
            if (target.closest('.form-dropdown-control')) {
                if (dropdown.classList.contains('is-opened')) {
                    dropdown.classList.remove('is-opened');
                } else {
                    closeAllDropdowns();
                    dropdown.classList.add('is-opened');
                }
            }
            // если кликнули на единичный выбор
            else if (target.closest('.form-dropdown-choice')) {
                let summary = '';
                if (target.classList.contains('is-selected')) {
                    target.classList.remove('is-selected');
                } else {
                    deselectChoices(dropdown);
                    target.classList.add('is-selected');
                    summary = target.innerText;
                }

                setSummary(dropdown, summary);
                closeAllDropdowns();
            }
            // если кликнули на мультивыбор
            // на чекбоксе генерируется два события
            else if (target.closest('.form-checkbox__control')) {
                const summary = getCheckboxesSummary(dropdown);
                setSummary(dropdown, summary);
            }
        }
        else {
            closeAllDropdowns();
        }
    });

}());